module.exports = __webpack_public_path__ + "static/media/mt-logo-mains.8eb430e4.svg";